import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';

@Component({
  selector: 'app-perfilamiento',
  templateUrl: './filtro-candidatos.component.html',
  styleUrls: ['./filtro-candidatos.component.scss']
})
export class FiltroCandidatosComponent implements OnInit {

  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;
  loading: any;
  formularioFiltro: FormGroup;

  // listas de registros
  registrosLista: any[] = [];
  listaCompetencias: any[] = [];
  listaHabilidades: any[] = [];
  listaConocimientosEspecificos: any[] = [];
  listaNivelEducativo: any[] = [];
  filtroActual: any = '';
  totalRecords = 0;
  listaAsignadosOrig: any[] = [];
  listaDisponibles: any[] = [];
  listaAsignados: any[] = [];
  ciudadesFiltradas: any[];
  cargandoPagina: boolean = false;

  /**
   * paginador
   */
  pageSize: Number = 5;
  cargoActual: any[];
  paginationOptions = {
    pageNumber: 1,
    rows: this.pageSize,
    pageLinkSize: 3,
    rowsPerPageOptions: [this.pageSize, 10, 15],
    totalRecords: 0
  };


  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private router: Router,
    private route: ActivatedRoute,
    private breadCrumbService: AppBreadcrumbService,
    public confirmationService: ConfirmationService
  ) {

    this.breadCrumbService.setItems([
      { label: 'Filtro Candidatos' }
    ]);

    this.formBuilder = new FormBuilder();

    this.formularioFiltro = this.formBuilder.group({
      requerimiento: [null, Validators.required],
      nivelEducativo: [''],
      ciudad: [''],
      profesion: [''],
      funciones: [''],
      desde: [''],
      hasta: [''],
      competencias: [''],
      habilidades: [''],
      conocimientos: [''],
      palabrasClave: [''],
      reutilizacion: [false],
      cargo: [null, Validators.required]
    });
    this.formularioFiltro.markAllAsTouched();
  }

  ngOnInit(): void {

    if (this.route.snapshot.queryParams.id) {
      this.filtroActual = this.route.snapshot.queryParams['id'];
    }

    this.getListaCompetencias();
    this.getListaHabilidades();
    this.getListaConocimientosEspecificos();
    this.getListaNivelEducativo();
  }

  /**
   * Validación
   */
  campoNoValido(campo: any) {
    return this.formularioFiltro.get(campo)?.invalid && this.formularioFiltro.get(campo)?.touched;
  }

  /**
   * listados
   */
  getListaCompetencias() {
    this.coreService.get('/listas/competencias').subscribe(
      (res: any) => {
        this.listaCompetencias = res;
      },
      (err: any) => {
      }
    )
  }

  getListaHabilidades() {
    this.coreService.get('/listas/habilidades').subscribe(
      (res: any) => {
        this.listaHabilidades = res;
      },
      (err: any) => {
      }
    )
  }

  getListaConocimientosEspecificos() {
    this.coreService.get('/listas/conocimientosEspecificos').subscribe(
      (res: any) => {
        this.listaConocimientosEspecificos = res;
      },
      (err: any) => {
      }
    )
  }

  getListaNivelEducativo() {
    this.coreService.get('/listas/nivelesEstudios').subscribe(
      (res: any) => {
        this.listaNivelEducativo = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  /**
   * Buscar candidato según el filtrado
   */
  buscar() {

    var dat = this.formularioFiltro.valid;
    if (dat) {
      let params = {
        page: this.paginationOptions.pageNumber,
        size: this.paginationOptions.rows
      };

      if (this.formularioFiltro.value.requerimiento !== "" && this.formularioFiltro.value.requerimiento !== null) {
        params['requerimiento'] = this.formularioFiltro.value.requerimiento;
      }
      if (this.formularioFiltro.value.desde !== "" && this.formularioFiltro.value.desde !== null) {
        params['desde'] = this.formularioFiltro.value.desde;
      }
      if (this.formularioFiltro.value.hasta !== "" && this.formularioFiltro.value.hasta !== null) {
        params['hasta'] = this.formularioFiltro.value.hasta;
      }
      if (this.formularioFiltro.value.competencias !== "" && this.formularioFiltro.value.competencias !== null && this.formularioFiltro.value.competencias.length !== 0) {
        params['competencias'] = JSON.stringify(this.formularioFiltro.value.competencias);
      }
      if (this.formularioFiltro.value.habilidades !== "" && this.formularioFiltro.value.habilidades !== null && this.formularioFiltro.value.habilidades.length !== 0) {
        params['habilidades'] = JSON.stringify(this.formularioFiltro.value.habilidades);
      }
      if (this.formularioFiltro.value.conocimientos !== "" && this.formularioFiltro.value.conocimientos !== null && this.formularioFiltro.value.conocimientos.length !== 0) {
        params['conocimientos'] = JSON.stringify(this.formularioFiltro.value.conocimientos);
      }
      if (this.formularioFiltro.value.nivelEducativo !== "" && this.formularioFiltro.value.nivelEducativo !== null) {
        params['nivel_educativo'] = JSON.stringify(this.formularioFiltro.value.nivelEducativo);
      }
      if (this.formularioFiltro.value.cargo !== "" && this.formularioFiltro.value.cargo !== null) {
        params['cargo'] = this.formularioFiltro.value.cargo.toUpperCase();
      }
      if (this.formularioFiltro.value.profesion !== "" && this.formularioFiltro.value.profesion !== null) {
        params['profesion'] = this.formularioFiltro.value.profesion.toUpperCase();
      }
      if (this.formularioFiltro.value.reutilizacion !== "" && this.formularioFiltro.value.reutilizacion !== null) {
        params['reutilizacion'] = this.formularioFiltro.value.reutilizacion;
      }
      if (this.formularioFiltro.value.palabrasClave != undefined) {
        params['palabras_clave'] = this.formularioFiltro.value.palabrasClave;
      }
      if (this.formularioFiltro.value.ciudad !== undefined && this.formularioFiltro.value.ciudad !== null && this.formularioFiltro.value.ciudad !== '') {
        params['ciudad_id'] = this.formularioFiltro.value.ciudad.ciudad_nombre;
        params['pais_id'] = this.formularioFiltro.value.ciudad.pais_nombre;
        params['departamento_id'] = this.formularioFiltro.value.ciudad.depto_nombre;
      }
      if (this.formularioFiltro.value.funciones != undefined) {
        params['funciones'] = this.formularioFiltro.value.funciones;
      }
      this.cargandoPagina = true;

      this.coreService.getWithParams('/filtro-candidatos', params).subscribe(
        (res: any) => {
          this.paginationOptions.totalRecords = res.total;
          this.registrosLista = res.data;
          this.cargandoPagina = false;
        },
        (err: any) => {
          console.log(err);
          this.registrosLista = [];
          this.paginationOptions.totalRecords = 0;
          this.cargandoPagina = false;
        }
      );
    } else {
      this.formularioFiltro.markAllAsTouched();
    }
  }

  /**
   * Asociar candidato
   */
  getAsociarReq(event) {
    this.confirmationService.confirm({
      message: '<center>¿Desea Asociar este Candidato a este Requerimiento?</center>',
      accept: () => {
        this.asociarReq(event);
      }
    });
  }

  asociarReq(event) {
    let params = {
      id: event
    };
    params['requerimiento'] = this.formularioFiltro.value.requerimiento;

    this.coreService.post('/asociar-candidatos', params).subscribe(
      (res: any) => {
        if (res.success) {
          this.msj.info(res.mensaje);
          this.cargandoPagina = false;
          this.buscar();
        } else {
          this.msj.error(res.mensaje);
          this.cargandoPagina = false;
        }
      },
      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }

  /**
   * Ver Hoja de Vida
   */
  getHdV(event, event2) {
    this.confirmationService.confirm({
      message: '<center>¿Desea Ver esta Hoja de Vida?</center>',
      accept: () => {
        /*
        this.router.navigate(['/hoja-vida-candidato/' + event +'/'+ event2]);  
        */
        window.open(window.location.pathname + '#/hoja-vida-candidato/' + event + '/' + event2, '_blank');
        /*
        console.log(event);
        console.log(event2);
        */
      }
    });
  }

  /**
   * Cambio de página
   */
  cambioPagina(event) {
    this.paginationOptions.rows = event.rows;
    this.paginationOptions.pageNumber = (event.first / event.rows) + 1;
    this.buscar();
  }

  mayusculaFunciones(e) {
    if (e.target.value !== null) {
      this.formularioFiltro.controls['funciones'].setValue(e.target.value.toUpperCase());
    }
  }

  mayusculaPalabrasClave(e) {
    if (e.target.value !== null) {
      this.formularioFiltro.controls['palabrasClave'].setValue(e.target.value.toUpperCase());
    }
  }

  mayusculaProfesion(e) {
    if (e.target.value !== null) {
      this.formularioFiltro.controls['profesion'].setValue(e.target.value.toUpperCase());
    }
  }

  filtrarCiudades(e) {
    let params = { texto: e.query }
    if (e.query.length > 2) {
      this.coreService.getWithParams('/lugares', params).subscribe(
        (res: any[]) => {
          this.ciudadesFiltradas = res;
        },
        (err: any) => {
          console.log(err);
        }
      )
    }
  }
}